const DARK = '#111111';
const LIGHT = '#ffffff';

const toLinear = (c) => {
  const v = c / 255;
  return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
};

// WCAG relative luminance for a 6-digit hex string (no leading '#').
const relativeLuminance = (m) => {
  const r = toLinear(parseInt(m.slice(0, 2), 16));
  const g = toLinear(parseInt(m.slice(2, 4), 16));
  const b = toLinear(parseInt(m.slice(4, 6), 16));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// WCAG contrast ratio between two relative luminances.
const contrastRatio = (a, b) =>
  (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);

const DARK_LUMINANCE = relativeLuminance('111111');
const LIGHT_LUMINANCE = relativeLuminance('ffffff');

// Returns the more readable text color ('#111111' dark, or '#ffffff' white) for
// a given hex background by comparing the actual WCAG contrast ratio of each
// candidate — a plain luminance threshold picks low-contrast text for medium
// backgrounds. Falls back to dark text when the input is missing or not a
// 6-digit hex.
const contrastColor = (hex) => {
  if (typeof hex !== 'string') return DARK;
  const m = hex.trim().replace(/^#/, '');
  if (!/^[0-9a-fA-F]{6}$/.test(m)) return DARK;

  const bg = relativeLuminance(m);
  const darkContrast = contrastRatio(bg, DARK_LUMINANCE);
  const lightContrast = contrastRatio(bg, LIGHT_LUMINANCE);

  return darkContrast >= lightContrast ? DARK : LIGHT;
};

// Builds the inline style for a card/tile in color mode: the configured
// background (white when unset), contrast-correct text, and a border matching
// the background so a tile's resting border doesn't clash with the color.
// Shared by Offerings, Category (subcategories), and CategoryProduct.
export const colorModeStyle = (color) => {
  const bg = color || '#ffffff';
  return {
    backgroundColor: bg,
    color: contrastColor(bg),
    borderColor: bg,
  };
};

export default contrastColor;
